var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('accnav',{attrs:{"list":_vm.navList,"curTitleId":_vm.curTitleId},on:{"titleChange":_vm.titleChange}}),_vm._v(" "),_c('div',[_c(_vm.child,{tag:"component"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3ecafaa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccExam/AccExam.vue
// module id = null
// module chunks = 